<template>
  <!-- CART DROPDOWN -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <feather-icon icon="ShoppingCartIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="carrito_actual.length" ref="carrito" />
      <vs-dropdown-menu class="cart-dropdown vx-navbar-dropdown" :class="{'dropdown-custom': carrito_actual.length}">

          <!-- IF CART HAVE ITEMS: HEADER -->
          <template v-if="carrito_actual.length">
              <div class="notification-header text-center p-5 bg-primary text-white">
                  <h3 class="text-white">{{ carrito_actual.length }} compra<span v-show="carrito_actual.length > 1">s</span></h3>
                  <p class="opacity-75">en tu carrito</p>
              </div>

              <!-- CART ITEMS -->
              <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--cart-items-dropdowm p-0 mb-10" :settings="settings" :key="$vs.rtl">
              <ul class="bordered-items">
                  <li
                    v-for="(reserva_nodo,i) in carrito_actual"
                    :key="i"
                    class="vx-row no-gutter cart-item cursor-pointer">


                      <!-- INFO COL -->
                      <div class="vx-col justify-center" style="padding: 10px 10px; position: relative; width: 100%;overflow: hidden">
                          <h5 class="titulo-item-carrito">{{ reserva_nodo.hijo.nombre }} {{ reserva_nodo.hijo.apellidos }}: {{ reserva_nodo.nodo.titulo }}</h5>
                            <div v-for="(extra,extra_i) in reserva_nodo.extras" :key="extra_i" class="truncate" style="color: gray">
                              {{extra.cantidad}} x {{ extra.extra.concepto }} ({{ extra.cantidad*extra.extra.precio }} €)
                            </div>
                          <div style="position: absolute; bottom: 5px; right: 0px">
                              <span class="font-medium" style="font-size: 17px; margin-right: 5px;">{{ reserva_nodo.precio_total }} €</span>
                              <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer text-danger" class="hover:text-danger" @click="quitar(reserva_nodo.index)" style="margin-bottom: -3px; display: inline-block;vertical-align: bottom;" />
                          </div>
                      </div>
                  </li>
              </ul>
              </VuePerfectScrollbar>
              <div
                class=" checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
                @click="ir_al_carrito()">

                <span class="flex items-center justify-center">
                  <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2">Revisar y pagar</span>
                </span>

              </div>
          </template>

          <!-- IF CART IS EMPTY -->
          <template v-else>
              <p class="p-4">Tu carrito está vacío.</p>
          </template>
      </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
    }
  },
  computed: {
    ...mapGetters(["carrito"]),
    // CART DROPDOWN
    carrito_actual(){
      var carrito_actual = []
      this.carrito.forEach((reserva_nodo,index) => {
        if(reserva_nodo.cantidad > 0 && reserva_nodo.reserva.estado == -1){
          reserva_nodo.index = index
          carrito_actual.push(reserva_nodo)
        }
      })
      return carrito_actual
    },
    cartItems() {
        return this.$store.state.eCommerce.cartItems.slice().reverse();
    },
  },
  methods: {
    removeItemFromCart(item) {
        this.$store.dispatch('eCommerce/toggleItemInCart', item)
    },
    quitar(index){
      this.$store.commit('quitar',index)
    },
    ir_al_carrito(){
      this.$refs.carrito.vsDropdownVisible = false
      this.$set(this.$refs.carrito, 'vsDropdownVisible', false)
      this.$refs.carrito.click()
      this.$router.push('/carrito/').catch(() => {  })
    }
  }
}

</script>


<style lang="scss">
.titulo-item-carrito{
  font-size: 11pt;
  width: calc(100% - 70px);
  font-weight: 200;
}
</style>